import { useDispatch } from 'react-redux';

import { updAdmin } from '../../../actions/admin';
import { valMsg } from '../../../actions/swal_msg';
import AdminPrivilegeSelector from './AdminPrivilegeSelector';
import { normalizeAdminPrivileges } from './adminPrivilegesConfig';

import {
    Box, Button, Container, Divider,
    Typography
} from '@mui/material';

const AdminPrivileges = ({
    values, setValues, inputErr, setInputErr, myRef, eInputRef, uInputRef, rInputRef, handleCloseDialog
}) => {
    const dispatch = useDispatch();
    const { username, email, role } = values;

    const update = () => {
        if (formValidator())
            dispatch(updAdmin({
                ...values,
                privileges: normalizeAdminPrivileges(values.privileges)
            }));
        handleCloseDialog();
    };

    // validación formulario
    const formValidator = () => {
        const email_len = email.trim().length;
        const username_len = username.trim().length;
        const role_len = role.trim().length;
        if (email_len > 5 && email_len <= 100) {
            if (username_len > 2 && username_len <= 100) {
                if (role_len > 2 && role_len <= 60)
                    return true;
                else {
                    rInputRef.current.select();
                    valMsg('warning', 'Administrador',
                        'Ingrese un rol para el usuario');
                }
            } else {
                uInputRef.current.select();
                valMsg('warning', 'Administrador',
                    'Ingrese un nombre de usuario apropiado');
            }
        } else {
            eInputRef.current.select();
            valMsg('warning', 'Administrador',
                'Ingrese un correo electrónico válido');
        }
        // establece errores en los campos
        setInputErr({
            ...inputErr,
            email_err: (email.length < 6 ||
                email.length > 100) ? true : false,
            username_err: (username.length < 3 ||
                username.length > 100) ? true : false,
            role_err: (role.length < 3 ||
                username.length > 100) ? true : false
        });
        return false;
    };

    return (
        <Container maxWidth='xl' sx={{ mb: 5 }} ref={myRef}>
            <Box sx={{ p:3, boxShadow: '0 2px 4px 2px rgb(0 0 0 / 20%)', borderRadius: '5px' }}>
                <Typography variant='h6' sx={{fontWeight: '600'}}>Administrar privilegios para: {username} </Typography>
                <Divider sx={{my: 2}} />
                <AdminPrivilegeSelector
                    privileges={values.privileges}
                    onChange={privileges => setValues({ ...values, privileges })}
                />
                <Box sx={{mt: 2, display: 'flex', justifyContent: 'flex-end'}}>
                    <Button variant='contained'
                        onClick={ update }>
                        Guardar cambios
                    </Button>
                </Box>
            </Box>
        </Container>
    );
};

export default AdminPrivileges;
